import { useNavigate } from 'react-router-dom'
import { Alert, Box, Button, CircularProgress, Stack, Typography } from '@mui/material'
import { Person, Sports } from '@mui/icons-material'
import { useRecruiterProfileForm } from '../../../hooks/useRecruiterProfileForm'
import { ProfileSection } from '../ProfileSection'
import { ContactInfoFields } from './ContactInfoFields'
import { RecruitingFocusFields } from './RecruitingFocusFields'

/** Single-page edit form: every field on one scroll, no stepper. */
export const RecruiterProfileEditForm = () => {
  const navigate = useNavigate()
  const form = useRecruiterProfileForm()

  const handleSave = async () => {
    const ok = await form.save()
    if (ok) {
      setTimeout(() => navigate('/profile'), 600)
    } else {
      setTimeout(() => {
        document.querySelector('[aria-invalid="true"]')?.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        })
      }, 50)
    }
  }

  if (form.isLoading) {
    return (
      <Box display="flex" justifyContent="center" py={8}>
        <CircularProgress />
      </Box>
    )
  }

  return (
    <Box>
      <Typography variant="h4" sx={{ fontWeight: 700, mb: 3 }}>
        Edit profile
      </Typography>

      {form.saved && (
        <Alert severity="success" sx={{ mb: 2 }}>
          Profile saved.
        </Alert>
      )}
      {form.isSaveHttpError && (
        <Alert severity="error" sx={{ mb: 2 }}>
          Failed to save profile. Please try again.
        </Alert>
      )}

      <Stack spacing={3}>
        <ProfileSection title="Contact" icon={<Person />}>
          <ContactInfoFields form={form} />
        </ProfileSection>

        <ProfileSection title="Recruiting focus" icon={<Sports />}>
          <RecruitingFocusFields form={form} />
        </ProfileSection>

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
          <Button onClick={() => navigate('/profile')} disabled={form.isSaving}>
            Cancel
          </Button>
          <Button variant="contained" onClick={handleSave} disabled={form.isSaving}>
            {form.isSaving ? 'Saving...' : 'Save changes'}
          </Button>
        </Box>
      </Stack>
    </Box>
  )
}
